module.exports = function() {
  return new Worker(__webpack_public_path__ + "7468065bf94d31acb2d9.worker.js");
};